export default "__VITE_ASSET__DWmjlDd5__"